import axios from 'axios'
import Cookies from 'js-cookie'
import { ADMIN_AUTH_PREFIX_PATH } from '../AppConfig'

const url = process.env.REACT_APP_HOST

const axiosInstance = axios.create({
  baseURL: `${url}api`,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor to add token and language dynamically
axiosInstance.interceptors.request.use(
  (config) => {
    const token = Cookies.get('SMARTCAF_JWT_TOKEN')
    const language = Cookies.get('i18next')
    
    if (token) {
      config.headers.Authorization = token
    }
    if (language) {
      config.headers.lang = language
    }
    
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      Cookies.remove('SMARTCAF_JWT_TOKEN', { path: '/' })
      window.location.href = `${ADMIN_AUTH_PREFIX_PATH}`
    }
    return Promise.reject(error)
  }
)

export const axiosFormData = axios.create({
  baseURL: `${url}api`,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
})

// Request interceptor for formData instance
axiosFormData.interceptors.request.use(
  (config) => {
    const token = Cookies.get('SMARTCAF_JWT_TOKEN')
    const language = Cookies.get('i18next')
    
    if (token) {
      config.headers.Authorization = token
    }
    if (language) {
      config.headers.lang = language
    }
    
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

axiosFormData.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      Cookies.remove('SMARTCAF_JWT_TOKEN', { path: '/' })
      window.location.href = `${ADMIN_AUTH_PREFIX_PATH}`
    }
    return Promise.reject(error)
  }
)

export default axiosInstance
